<template>
  <!-- 'v-transfer-dom' - from 'vue-transfer-dom' component: append to body (default) -->
  <div class="popup" v-transfer-dom>
    <!-- The Modal -->
    <transition name="fade" mode="out-in">
      <div v-if="isPopupShown" class="w3-modal" @click.prevent>
        <div class="w3-modal-content">
          <simplebar data-simplebar-auto-hide="false">
            <div class="container">
              <div>
                <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                <div class="w3-container">
                  <div v-if="title" class="w3-row popup-title">
                    {{ title }}
                  </div>
                  <div class="w3-row popup-content">
                    <definition v-if="content"
                      :type="type"
                      :content="content"
                      :id="id"
                      :language="language"
                      :visuals="visuals"
                      :authorization="authorization"
                      :apiparams="apiparams"
                      :showloading="true"
                      :fromPopup="true"
                      :fromPopupId="definitionContentId"
                      @refreshDefinition="refreshDefinition"
                      @popupClose="popupClose"
                    />
                    <span class="txtPopup" v-else>{{ txtContent }}</span>
                  </div>
                </div>
              </div>
            </div>
          </simplebar>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import simplebar from 'simplebar-vue'
import 'simplebar/dist/simplebar.min.css'

export default {
  name: 'popup',
  props: [
    'isPopupShown',
    'title',
    'type',
    'content',
    'txtContent',
    'id',
    'language',
    'authorization',
    'visuals',
    'apiparams',
    'definitionContentId'
  ],
  data () {
    return {
    }
  },
  components: {
    simplebar,
    Definition: () => import('../definition.vue') // Webpack’s asynchronous import for recursivity components
  },
  methods: {
    popupClose () {
      this.$emit('popupClose')
    },
    refreshDefinition (newRequestObject) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/popup/index.vue